import React from 'react'
import { statusLabel, statusTone } from './model'

// A lead's (or a blocked submission's) status, coloured by the backend's code.
export default function StatusPill({ status, size = 'sm' }) {
  const tone = statusTone(status)
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
        padding: size === 'lg' ? '4px 12px' : '2px 9px', borderRadius: 999,
        fontSize: size === 'lg' ? 13 : 12, fontWeight: 600, color: tone.fg, background: tone.bg,
      }}
    >
      <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: 999, background: tone.fg }} />
      {statusLabel(status)}
    </span>
  )
}

// A small coloured label for an outcome (a buyer's result, a step's outcome).
export function Tag({ tone, children }) {
  return (
    <span style={{ display: 'inline-block', padding: '1px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', color: tone.fg, background: tone.bg }}>
      {children}
    </span>
  )
}
